// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QXUF","importantInfo":"styles_importantInfo__39pbh"};